import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderFieldsAdapter = getAdapter({ idFieldName: 'name' });

const orderFieldsSlice = createSlice({
  name: 'orderFields',
  initialState: orderFieldsAdapter.getInitialState(),
  reducers: {
    setOrderFields: (state, { payload: { orderFields } }) => {
      orderFieldsAdapter.setAll(state, orderFields);
    },
  },
});

const selectors = orderFieldsAdapter.getSelectors(({ orderFields }) => orderFields);

export const getOrderFields = (state) => selectors.selectAll(state);

export const {
  setOrderFields,
} = orderFieldsSlice.actions;

export default orderFieldsSlice.reducer;